// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r5-0";
export var leftAlign = "_r5-4";
export var listItem = "_r5-2";
export var listItemWrapper = "_r5-1";
export var operationText = "_r5-3";